import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";

type MissingPreviewPlaceholderProps = {
  icon: IconDefinition;
  primaryText: string;
  secondaryText: string;
};

export function MissingPreviewPlaceholder({
  icon,
  primaryText,
  secondaryText,
}: MissingPreviewPlaceholderProps) {
  const { lang } = useContext(PspContext);

  return (
    <div className="text-font-secondary flex flex-col text-center items-center gap-12 h-full justify-center">
      <FontAwesomeIcon icon={icon} className="text-9xl" />
      <div className="flex flex-col">
        <div className="text-xl">{primaryText}</div>
        <div className="text-base">{secondaryText}</div>
      </div>
      <div className="italic">({translate("noPreviewAvailable", lang)})</div>
    </div>
  );
}
